import { Box } from "grommet";
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { Dimensions } from 'react-native';
import Background from '../assets/background.svg'
import BackgroundBands from '../assets/background-bands.png'

const AnimatedBackgroundBox = styled(Box)`
.anchor-circle {
  transform: translate3d(0, 0, 0);
  filter: blur(500px);
  width: 1100px;
  height: 1100px;
  opacity: 0.8;
  background: #e6263d;
  border-radius: 30%;
  content: "";
  position: fixed;
  left: -900px;
  top: -900px;
  z-index: -1;
}
@media (max-width: 991px) {
  .anchor-circle {
    filter: blur(150px);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
  }
}

.runing_round .anchor-circle {
  animation: runing_round 16s linear infinite;
}

.reset_round .anchor-circle {
  animation: reset_round 16s linear infinite;
}

.reset_round_other .anchor-circle {
  animation: reset_round_other 16s linear infinite;
}

.firefox-browser-device .anchor-circle {
  background: rgba(230, 38, 61, 0.1);
  transform: translate3d(0, 0, 0);
  filter: blur(500px);
  width: 1000px;
  height: 1000px;
  opacity: 1;
  border-radius: 50%;
  content: "";
  position: fixed;
  left: 0;
  top: 0;
}
.firefox-browser-device .runing_round .anchor-circle {
  animation: orbit_firefox 16s linear infinite;
}
.firefox-browser-device .reset_round .anchor-circle {
  animation: reset_round_firefox 16s linear infinite;
}
.firefox-browser-device .reset_round_other .anchor-circle {
  animation: reset_round_other_firefox 16s linear infinite;
}
.firefox-browser-device.current-white .anchor-circle {
  background: rgba(5, 102, 219, 0.2);
}

@keyframes runing_round {
  0% {
    left: -1000px;
    top: -1000px;
    width: 1100px;
    height: 1100px;
  }
  25% {
    width: 1000px;
    height: 1000px;
    left: calc(100% - 50px);
    top: -1000px;
  }
  50% {
    left: calc(100% - 50px);
    top: calc(100% - 50px);
    width: 1100px;
    height: 1100px;
  }
  75% {
    width: 1200px;
    height: 1200px;
    left: -1200px;
    top: calc(100% - 50px);
  }
  100% {
    left: -1000px;
    top: -1000px;
    width: 1100px;
    height: 1100px;
  }
}
@keyframes reset_round {
  0% {
    left: calc(100% - 50px);
    top: calc(100% - 50px);
    width: 1100px;
    height: 1100px;
  }
  25% {
    width: 1000px;
    height: 1000px;
    left: calc(100% - 50px);
    top: -1000px;
  }
  50% {
    left: -1000px;
    top: -1000px;
    width: 1100px;
    height: 1100px;
  }
  75% {
    width: 1100px;
    height: 1100px;
    left: -1000px;
    top: calc(100% - 50px);
  }
  100% {
    left: calc(100% - 50px);
    top: calc(100% - 50px);
    width: 1100px;
    height: 1100px;
  }
}
@keyframes reset_round_other {
  0% {
    left: calc(100% - 50px);
    top: calc(100% - 50px);
    width: 1100px;
    height: 1100px;
  }
  25% {
    width: 1100px;
    height: 1100px;
    left: -1000px;
    top: calc(100% - 50px);
  }
  50% {
    left: -1000px;
    top: -1000px;
    width: 1100px;
    height: 1100px;
  }
  75% {
    width: 1100px;
    height: 1100px;
    left: -1000px;
    top: calc(100% - 50px);
  }
  100% {
    left: -1000px;
    top: -1000px;
    width: 1100px;
    height: 1100px;
  }
}
@keyframes orbit_firefox {
  0%, 100% {
    left: -950px;
    transform: translate(100px, 100px);
    top: -950px;
    width: 1100px;
    height: 1100px;
  }
  25% {
    left: calc(100% - 150px);
    top: -950px;
    transform: translate(100px, 100px);
    width: 1000px;
    height: 1000px;
  }
  50% {
    left: calc(100% - 150px);
    top: calc(100% - 150px);
    transform: translate(100px, 100px);
    width: 1100px;
    height: 1100px;
  }
  75% {
    left: -950px;
    top: calc(100% - 150px);
    transform: translate(100px, 100px);
    width: 1200px;
    height: 1200px;
  }
}
@keyframes reset_round_firefox {
  0% {
    left: -650px;
    top: calc(100% - 150px);
    transform: translate(100px, 100px);
    width: 1100px;
    height: 1100px;
  }
  25% {
    left: calc(100% - 150px);
    top: calc(100% - 150px);
    transform: translate(100px, 100px);
    width: 1000px;
    height: 1000px;
  }
  50% {
    left: calc(100% - 150px);
    top: -950px;
    transform: translate(100px, 100px);
    width: 1100px;
    height: 1100px;
  }
  75% {
    left: calc(100% - 150px);
    top: calc(100% - 150px);
    transform: translate(100px, 100px);
    width: 1200px;
    height: 1200px;
  }
  100% {
    left: calc(100% - 150px);
    top: -950px;
    transform: translate(100px, 100px);
    width: 1100px;
    height: 1100px;
  }
}
@keyframes reset_round_other_firefox {
  0%, 100% {
    left: calc(100% - 150px);
    top: -950px;
    transform: translate(100px, 100px);
    width: 1100px;
    height: 1100px;
  }
  25% {
    left: -950px;
    top: -950px;
    transform: translate(100px, 100px);
    width: 1000px;
    height: 1000px;
  }
  50% {
    left: -950px;
    top: calc(100% - 150px);
    transform: translate(100px, 100px);
    width: 1100px;
    height: 1100px;
  }
  75% {
    top: -950px;
    left: -950px;
    transform: translate(100px, 100px);
    width: 1200px;
    height: 1200px;
  }
}
.current-white .anchor-circle {
  background: #0566db;
}

.canvas-circle {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  left: 0;
  top: 0;
  position: fixed;
  z-index: -1;
}

@media print {
  display: none;
}
`

const AnimatedBackground = () => {

    const [backgroundAnimationClass, setBackgroundAnimationClass] = useState('canvas-circle runing_round');
    const [windowHeight, setWindowHeight] = useState();

    useEffect(() => {
        (function _loop(idx) {
            setTimeout(function () {
                setBackgroundAnimationClass('canvas-circle runing_round');
            }, idx + 6000);
            setTimeout(function () {
                setBackgroundAnimationClass('canvas-circle reset_round');
            }, idx + 14000);
            setTimeout(function () {
                setBackgroundAnimationClass('canvas-circle reset_round_other');
            }, idx + 30000);

            setTimeout(function () {
                _loop((idx + 1) % 3);
            }, 40000);
        })(0);
    }, []);

    useEffect(() => {
        const subscription = Dimensions.addEventListener(
            'change',
            ({ window }) => {
                setWindowHeight(window.height);
            },
        );
        return () => subscription?.remove();
    });
    
    return (
        <AnimatedBackgroundBox>
            {
                window?.innerWidth > 1045 ?
                    (
                        <div className={backgroundAnimationClass} style={{ background: `url(${BackgroundBands}) 80% / contain no-repeat, url(${Background}) 100% / cover, linear-gradient(135deg, #010516 0%, #030B33 100%)` }}>
                            <div className="anchor-circle" style={{ overflow: 'hidden' }}></div>
                        </div>
                    ) : (
                        <div className={backgroundAnimationClass} style={{ background: `url(${BackgroundBands}) 45% / cover no-repeat, url(${Background}) 100% / cover, linear-gradient(135deg, #010516 0%, #030B33 100%)` }}>
                            <div className="anchor-circle" style={{ overflow: 'hidden' }}></div>
                        </div>
                    )
            }

        </AnimatedBackgroundBox>)
}

export { AnimatedBackground }